export default "__VITE_ASSET__68f1d04c__"